module.exports = __webpack_public_path__ + "img/accept-store.49cb7b8e.png";